import type { FeaturesResponse } from 'api/internalResources/featureFlag';
import type { AssistantType } from 'api/types';
import {
  PROJECT_RESOURCE,
  type ProjectResource,
  RESOURCE_PROJECT_TYPE_MAP,
} from 'hooks/useProjectResources';

export const isFeatureEnabled = (
  features: FeaturesResponse,
  featureName: string,
) => !!features.find(f => f.name === featureName && f.enabled);

export const hasFeatureAccess = (
  resource: ProjectResource,
  features: string[],
  restrictedFeatures: string[],
  projectType?: AssistantType,
) => {
  const resourceProjectType = RESOURCE_PROJECT_TYPE_MAP[resource];
  if (
    projectType &&
    resourceProjectType &&
    projectType !== 'hybrid' &&
    resourceProjectType !== 'hybrid' &&
    projectType !== resourceProjectType
  ) {
    return false;
  }
  if (features.includes('*')) {
    return !restrictedFeatures?.includes(resource);
  }
  // Special case: Language hub uses settings permissions
  if (resource === PROJECT_RESOURCE.LANGUAGE_HUB) {
    return features.includes('settings');
  }
  return features.includes(resource);
};
